import type { TranslateResult } from 'vue-i18n'
import { definePropType } from '@types-vue/props'
import { SegmentCollection } from 'video-editor-renderer'

export interface ApplyPropType {
  enable: boolean
  text: TranslateResult
}

export const ApplyProp = {
  // 是否启用 应用按钮
  applyAll: {
    type: definePropType<ApplyPropType>(Object),
  },
}

export function computedPercent(
  segment: SegmentCollection,
  relativeSegment: SegmentCollection,
): { percent_x: number; percent_y: number } {
  return {
    percent_x:
      ((segment.x - relativeSegment.x) / (relativeSegment.width / 2)) * 100,

    percent_y:
      ((segment.y - relativeSegment.y) / (relativeSegment.height / 2)) * 100,
  }
}
